import { create } from 'zustand';
export const useStreakCompletionResultStore = create((set) => ({
    streakCompletionResult: null,
    setStreakCompletionResult: (streakCompletionResult) => set({ streakCompletionResult }),
    resetStreakCompletionResult: () => set({ streakCompletionResult: null }),
}));
